import image from './images/1.jpg'

const InstagramIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
)

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="bg-white py-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-6 items-center">
        <div className="flex flex-col gap-2 items-center text-center">
          <p className="text-[16px] text-accent font-dm-serif font-medium">About</p>
          <h2 className="text-[22px] font-bold text-black">私たち、FLOWERについて</h2>
        </div>
        <img src={image} alt="FLOWERのチーム" className="w-full object-cover rounded-2xl" />
        <div className="flex flex-col gap-3">
          <h3 className="text-[16px] font-bold text-black text-center leading-[1.4]">
            累計150万束以上届けてきた
            <br />
            オンラインのお花屋さん
          </h3>
          <p className="text-[13px] leading-[1.6] text-black">
            お花のロス（廃棄）を生み出さない独自の販売の仕組みで、手頃な価格を実現。毎日全国のお客様にたくさんのお花をお届けしています。日々ブーケやお花のお手入れ方法などを紹介しているので、ぜひInstagramをチェックしてみてください！
          </p>
        </div>
        <a
          href="https://www.instagram.com/flowr_is/"
          target="_blank"
          rel="noreferrer"
          className="flex items-center justify-center gap-1.5 border border-black rounded-3xl h-11 px-10 text-[13px] font-bold text-black hover:bg-black hover:text-white transition-colors"
        >
          <InstagramIcon className="w-4 h-4" />
          FLOWER公式Instagram
        </a>
      </div>
    </section>
  )
}
